import { useEffect } from "react";
import apiClient from "../business/network/ApiClient";

const FIVE_MINUTES = 5 * 60 * 1000;
const REDIRECT_URL = "https://central.greenroad.com/";

const useSessionWatcher = () => {
    useEffect(() => {
        const checkSession = async () => {
            try {
                const isValid = await apiClient.IsSessionValid();
                console.log("Session is valid:", isValid);
                if (!isValid) {
                    window.location.href = REDIRECT_URL;
                }
            } catch (error) {
                console.error("Session check failed:", error);
                window.location.href = REDIRECT_URL;
            }
        };

        const interval = setInterval(checkSession, FIVE_MINUTES);

        return () => clearInterval(interval);
    }, []);
};

export default useSessionWatcher;